export default __webpack_public_path__ + "static/media/flatmatch.81d4bc5a.jpg";